// GameRates.js
import React from "react";
import "./GameRates.css";
import { useSelector } from "react-redux";
const GameRates = () => {

  const { game_results } = useSelector((state) => state.users);

//   const rates = [
//     { category: "Single Digit", ratio: "10 KA 95" },
//     { category: "Jodi", ratio: "10 KA 950" },
//     { category: "Single Panna", ratio: "10 KA 1400" },
//     { category: "Double Panna", ratio: "10 KA 2800" },
//     { category: "Tripple Panna", ratio: "10 KA 7000" },
//     { category: "Half Sangam", ratio: "10 KA 10000" },
//     { category: "Full Sangam", ratio: "10 KA 100000" },
//   ];

  return (
    <div className="game-rates-container">
      <h2 className="title">Main Game Win Ratio For All Bids</h2>
      <table className="rates-table">
        <thead>
          <tr>
            <th>Category</th>
            <th>Win Ratio</th>
          </tr>
        </thead>
        <tbody>
          { game_results?.map((rate, index) => (
            <tr key={index}>
              <td>{rate.type}</td>
              <td>{`${rate.min_value} KA ${rate.max_value}`}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default GameRates;